(function(){
  if (window.__ecoBuybackStepperLoaded) return;
  window.__ecoBuybackStepperLoaded = true;

  var $ = function(id){ return document.getElementById(id); };

 var ECO_OFFER_ENDPOINT = "https://script.google.com/macros/s/AKfycbxgOgUY6RHdNi--y0Holrepyu4-Kb90ao3TJD1edZM92LAopcmYU7Ca9RWKs26zlWo2/exec";

  var state = {
    step: 0,
    condition: 0,
    category: "iphone",
    navStage: 0,
    deviceGroup: "",
    brandName: "",
    familyName: "",
    series: "all",
    model: "",
    storage: "",
    akkuPercent: 85,
    picks: {
      akku: "D_Akku_Jo_Ft",
      kijelzo: "D_Kijelzo_Karcmentes_Ft",
      keret: "D_Keret_Szep_Ft",
      hatlap: "D_Hatlap_Szep_Ft",
      beeges: "D_Beeges_Nincs_Ft",
      pixel: "D_Pixelhiba_Nincs_Ft",
      tartozek: "D_Tartozek_Megvan_Ft"
    }
  };

  var items = [];
  var visible = 12;

  var steps = [
    "K\u00E9sz\u00FCl\u00E9k",
    "Modell",
    "T\u00E1rhely",
    "\u00C1llapot",
    "Aj\u00E1nlat"
  ];

  var conds = [
    [
      "akku",
      "Akkumul\u00E1tor \u00E1llapota",
      [
        ["D_Akku_Jo_Ft","J\u00F3","85% felett"],
        ["D_Akku_Elfogadhato_Ft","Elfogadhat\u00F3","80-84%"],
        ["D_Akku_Cseres_Ft","Cser\u00E9s","80% alatt"]
      ]
    ],

    [
      "kijelzo",
      "Kijelz\u0151 \u00E1llapota",
      [
        ["D_Kijelzo_Karcmentes_Ft","Karcmentes","Sz\u00E9p kijelz\u0151"],
        ["D_Kijelzo_MinKarc_Ft","Mini karc","Apr\u00F3 haszn\u00E1lati nyom"],
        ["D_Kijelzo_Karcos_Ft","Karcos","L\u00E1that\u00F3 karcok"],
        ["D_Kijelzo_Torett_Ft","T\u00F6r\u00F6tt","S\u00E9r\u00FClt kijelz\u0151"]
      ]
    ],

    [
      "keret",
      "Keret \u00E1llapota",
      [
        ["D_Keret_Szep_Ft","Sz\u00E9p","Norm\u00E1l \u00E1llapot"],
        ["D_Keret_Karcos_Ft","Karcos","Haszn\u00E1lati nyomok"],
        ["D_Keret_Serult_Ft","S\u00E9r\u00FClt","\u00DCt\u0151d\u00E9s vagy s\u00E9r\u00FCl\u00E9s"]
      ]
    ],

    [
      "hatlap",
      "H\u00E1tlap \u00E1llapota",
      [
        ["D_Hatlap_Szep_Ft","Sz\u00E9p","Norm\u00E1l \u00E1llapot"],
        ["D_Hatlap_Karcos_Ft","Karcos","L\u00E1that\u00F3 karcok"],
        ["D_Hatlap_Torett_Ft","Repedt","Repedt vagy t\u00F6r\u00F6tt"]
      ]
    ],

    [
      "beeges",
      "Be\u00E9g\u00E9s",
      [
        ["D_Beeges_Nincs_Ft","Nincs","Nincs be\u00E9g\u00E9s"],
        ["D_Beeges_Van_Ft","Van","L\u00E1that\u00F3 be\u00E9g\u00E9s"]
      ]
    ],

    [
      "pixel",
      "Pixelhiba",
      [
        ["D_Pixelhiba_Nincs_Ft","Nincs","Nincs pixelhiba"],
        ["D_Pixelhiba_Van_Ft","Van","L\u00E1that\u00F3 pixelhiba"]
      ]
    ],

    [
      "tartozek",
      "Tartoz\u00E9kok",
      [
        ["D_Tartozek_Megvan_Ft","Megvan","Doboz vagy t\u00F6lt\u0151"],
        ["D_Tartozek_Nincs_Ft","Nincs","Tartoz\u00E9k n\u00E9lk\u00FCl"]
      ]
    ]
  ];

  var cats = [
    ["iphone","Apple iPhone","EcoMobil Etele aj\u00E1nlat"],
    ["watch","Apple Watch","Hamarosan"],
    ["ipad","Apple iPad","Hamarosan"],
    ["galaxy-s","Galaxy S","Hamarosan"],
    ["galaxy-a","Galaxy A","Hamarosan"]
  ];

  function getSeriesList(){

  var found = [];

  itemList().forEach(function(x){

    var model = String(x.Model || "");

    if(state.category === "iphone"){

      var iphoneMatch = model.match(/iPhone\s+(\d+)/i);

      if(iphoneMatch){
        found.push(iphoneMatch[1]);
      }

    }

    if(state.category === "galaxy-s"){

      var sMatch = model.match(/Galaxy\s+S(\d+)/i);

      if(sMatch){
        found.push("S" + sMatch[1]);
      }

    }

    if(state.category === "galaxy-a"){

      var aMatch = model.match(/Galaxy\s+A(\d+)/i);

      if(aMatch){
        found.push("A" + aMatch[1]);
      }

    }

  });

  found = uniq(found);

  found.sort(function(a,b){

    var na = Number(String(a).replace(/\D/g,""));
    var nb = Number(String(b).replace(/\D/g,""));

    return na - nb;
  });

  var out = [
    ["all","\u00D6sszes"]
  ];

  found.forEach(function(s){
    out.push([s,s]);
  });

  return out;
}

  var imgs = {
    "Galaxy S21":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S21_-_Phantom_Black-_Overlap_Trans-cropped_e3adab9b-a424-499d-9a6b-e57098d8e3c3.webp?v=1742406090",

"Galaxy S21+":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S21_-Phantom_Gray-_Overlap_Trans-cropped_b0a75782-e9aa-43ce-bf1f-41e79236eda9.webp?v=1742406090",

"Galaxy S21 Ultra":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S21_Ultra_-Phantom_Black-_Overlap_Trans-cropped_b4a77f1a-0e95-4e6c-8403-291483998d3f.webp?v=1742406090",

"Galaxy S21 FE":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S21_FE_-_Graphite-_Overlap_Trans-cropped_eb1e42f8-c79e-42ff-8f9d-51efcde47aae.webp?v=1742406090",

"Galaxy S22":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S22_-_Phantom_black-_Overlap_Trans-cropped_1fdb6d7d-9947-4f77-a265-2d228a337195.webp?v=1742406090",

"Galaxy S22 Ultra":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S22_Ultra_-_black_-_Overlap_Trans-cropped_99d4ab9d-0cf5-41e4-9662-1ce452c88cb1.webp?v=1742406090",

"Galaxy S23":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S23_-_black_-_Overlap_Trans-cropped.webp?v=1742406090",

"Galaxy S23+":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S23_-_black_-_Overlap_Trans-cropped_60d585df-fbbb-463a-8893-22e3b3457c1d.webp?v=1742406090",

"Galaxy S23 Ultra":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S23_Ultra_-_Black-_Overlap_Trans-cropped.webp?v=1742406090",

"Galaxy S23 FE":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S23_FE_-_Graphite_-_Overlap-cropped.webp?v=1742406090",

"Galaxy S24":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/GalaxyS24_-OnyxBlack-Overlap_masolata.webp?v=1742406090",

"Galaxy S24+":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/GalaxyS24_-OnyxBlack-Overlap.webp?v=1742406090",

"Galaxy S24 Ultra":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S24_Ultra_-_Titanium_Grey_-_Overlap_Trans-cropped.webp?v=1742406090",

"Galaxy S24 FE":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/GalaxyS24FE-Graphite-Overlap-cropped.webp?v=1742406091",

"Galaxy S25":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/ChatGPT_Image_2026._szept._14._16_25_55.png?v=1789396315",

"Galaxy S25 FE":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/ChatGPT_Image_2026._szept._14._16_43_49.png?v=1789397109",

"Galaxy S22+":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/ChatGPT_Image_2026._szept._14._16_44_49.png?v=1789397111",

"Galaxy S25+":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/ChatGPT_Image_2026._szept._14._16_26_57.png?v=1789396317",

"Galaxy S25 Ultra":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/ChatGPT_Image_2026._szept._14._16_25_29.png?v=1789396315",

"Galaxy S26":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/ChatGPT_Image_2026._szept._14._16_29_46.png?v=1789396318",

"Galaxy S26+":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/ChatGPT_Image_2026._szept._14._16_29_55.png?v=1789396318",

"Galaxy S26 Ultra":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/ChatGPT_Image_2026._szept._14._16_30_30.png?v=1789396318",

    "iPhone 17 Pro Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0560.webp?v=1770413286",

    "iPhone 17 Pro":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0559.webp?v=1770413286",

    "iPhone 17":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0558.webp?v=1770413286",

    "iPhone Air":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0557.webp?v=1770413285",

    "iPhone 16e":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image5.jpg?v=1756759106",

    "iPhone 16 Pro Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image7.jpg?v=1756757823",

    "iPhone 16 Pro":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image6.jpg?v=1756757789",

    "iPhone 16 Plus":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image1.jpg?v=1756755651",

    "iPhone 16":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/image1.jpg?v=1756755651",

    "iPhone 15":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_15_-_Black_-_Overlap_Trans-cropped.webp?v=1742390891",

    "iPhone 15 Plus":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_15_-_Black_-_Overlap_Trans-cropped.webp?v=1742390891",

    "iPhone 15 Pro":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_15_Pro_-_Black_titanium-_Overlap_Trans-cropped_c47e786c-4113-4fb6-b720-5670985120cc.webp?v=1742388570",

    "iPhone 15 Pro Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_15_Pro_Max_-_Black_Titanium_-_Overlap_Trans-cropped_a7a9450f-79ec-43ab-93bd-d24e5d77b7ce.webp?v=1742388570",

    "iPhone 14":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_14_-_Black_-_Overlap_Trans-cropped_a3afa9da-f115-4a37-9ebc-6df335ac686f.webp?v=1742391257",

    "iPhone 14 Plus":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_14_-_Black_-_Overlap_Trans-cropped_a3afa9da-f115-4a37-9ebc-6df335ac686f.webp?v=1742391257",

    "iPhone 14 Pro":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_14_Pro_Max_-_Black_-_Overlap_Trans-cropped.webp?v=1742391065",

    "iPhone 14 Pro Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_14_Pro_Max_-_Black_-_Overlap_Trans-cropped.webp?v=1742391065",

    "iPhone 13":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_13_-_Black_-_Overlap_Trans-cropped_afb14423-b817-4bcc-bb23-8a2407567f18.webp?v=1742388570",

    "iPhone 13 Mini":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_13_Mini_-_Black_-_Overlap_Trans-cropped_efa61981-1000-4a8f-83ef-a67189218e31.webp?v=1742388570",

    "iPhone 13 Pro":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_13_Pro_-_Black_-_Overlap_Trans-cropped_15898d1b-010e-4167-8194-53fb0619264d.webp?v=1742388570",

    "iPhone 13 Pro Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_13_Pro_Max_-_Black_-_Overlap_Trans-cropped_7531de39-1a8e-4efc-8898-ce0143538e8e.webp?v=1742388570",

    "iPhone 12":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_12_-_Black_-_Overlap_Trans-cropped_3501494a-71c1-44ff-b496-c5ce57835e47.webp?v=1742388570",

    "iPhone 12 Mini":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_12_Mini_-_Black_-_Overlap_Trans-cropped_d9eda54c-065b-4f4c-891f-e4dbef8903eb.webp?v=1742388570",

    "iPhone 12 Pro":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_12_Pro_-_Black_-_Overlap_Trans-cropped_30088212-f9d7-4865-9dc0-9c520d3c4a8e.webp?v=1742388570",

    "iPhone 12 Pro Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_12_Pro_Max_-_Black_-_Overlap_Trans-cropped_e09c64b4-92f8-45e7-a8e3-3e03424841f1.webp?v=1742388570",

    "iPhone 11":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_11_-_Black_-_Overlap_Trans-cropped_1b1edca0-0b97-4b08-81d9-00f0163879d3.webp?v=1742388570",

    "iPhone 11 Pro":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_11_Pro_-_Black_-_Overlap_Trans-cropped_f2132f29-1bd7-4d15-ba97-a781c1b64827.webp?v=1742388569",

    "iPhone 11 Pro Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_11_Pro_Max_-_Black_-_Overlap_Trans-cropped_551b0f50-18cc-402d-8882-368a542b3e99_1.webp?v=1742392878",

    "iPhone XS":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone Xs":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone XS Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_Max_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone Xs Max":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_Max_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone XR":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XR_-_Black-_Overlap_Trans-cropped_36ba490b-723f-4c67-a3f2-fdb5a244c315.webp?v=1742388570",

    "iPhone X":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_XS_-_Space_Grey-_Overlap_Trans-cropped.webp?v=1742388570",

    "iPhone 8":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_SE_2nd_Gen_-_Black-_Overlap_Trans-cropped_b1988eb1-da2e-4337-918a-99e1010819db.webp?v=1742388570",

    "iPhone 8 Plus":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_SE_2nd_Gen_-_Black-_Overlap_Trans-cropped_b1988eb1-da2e-4337-918a-99e1010819db.webp?v=1742388570",

    "iPhone SE (2020)":"https://cdn.shopify.com/s/files/1/0862/7801/3256/files/iPhone_SE_2nd_Gen_-_Black-_Overlap_Trans-cropped_b1988eb1-da2e-4337-918a-99e1010819db.webp?v=1742388570"
  };


  function esc(s){
    return String(s || "").replace(
      /[&<>"']/g,
      function(c){
        return {
          "&":"&amp;",
          "<":"&lt;",
          ">":"&gt;",
          '"':"&quot;",
          "'":"&#039;"
        }[c];
      }
    );
  }


  function fmt(n){
    try{
      return new Intl.NumberFormat("hu-HU").format(n) + " Ft";
    }catch(e){
      return n + " Ft";
    }
  }


  function uniq(a){
    var o=[];

    a.forEach(function(x){
      if(x && o.indexOf(x)<0){
        o.push(x);
      }
    });

    return o;
  }


  function norm(v){
    return String(v == null ? "" : v).trim().toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function typeOf(m){
    m=norm(m);
    if(m.indexOf("watch")>-1) return "watch";
    if(m.indexOf("ipad")>-1) return "ipad";
    if(m.indexOf("galaxy s")>-1) return "galaxy-s";
    if(m.indexOf("galaxy a")>-1) return "galaxy-a";
    if(m.indexOf("iphone")>-1) return "iphone";
    return "other";
  }

  function categoryOf(x){
    var known=typeOf(x.Model);
    if(known!=="other") return known;
    var brand=norm(x.Brand), cat=norm(x.Category), model=norm(x.Model);
    if(brand==="xiaomi" || brand==="redmi" || brand==="poco" ||
       cat==="redmi" || cat==="poco" || model.indexOf("redmi")===0 || model.indexOf("poco")===0){
      if(cat==="redmi" || model.indexOf("redmi")===0) return "redmi";
      if(cat==="poco" || model.indexOf("poco")===0) return "poco";
      return "xiaomi";
    }
    if(brand.indexOf("playstation")>=0 || cat.indexOf("playstation")>=0 || model.indexOf("ps5")===0 || model.indexOf("ps4")===0 || brand==="sony") return "playstation";
    if(brand.indexOf("xbox")>=0 || cat.indexOf("xbox")>=0 || model.indexOf("xbox")===0 || brand==="microsoft") return "xbox";
    if(brand.indexOf("nintendo")>=0 || cat.indexOf("nintendo")>=0 || model.indexOf("switch")>=0) return "nintendo";
    // Uj markaknal a Sheets Brand + Category mezoi adjak a stabil kulcsot.
    // A teljesen uj tipusokat is megjelenitjuk kodmodositas nelkul.
    var b=norm(x.Brand).replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");
    var c=norm(x.Category).replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");
    if(!b && !c) return "other";
    return "dynamic-"+(b||"egyeb")+"--"+(c||"altalanos");
  }

  function isConsoleCategory(key){
    return ["playstation","xbox","nintendo"].indexOf(key)!==-1 ||
      /^dynamic-(sony|playstation|microsoft|xbox|nintendo)--/.test(key);
  }

  function skipsBattery(){
    // iPhone / Apple Watch / iPad regi mukodese megmarad.
    // Az ujonnan felvitt androidos markaknal sincs akku-levonas.
    return ["iphone", "watch", "ipad"].indexOf(state.category) === -1;
  }

  function activeItem(x){
    var a=norm(x.Active);
    return Number(x.BasePriceFt||0)>0 &&
      (a==="" || a==="igen" || a==="true" || a==="1" || a==="yes");
  }

  function allCategories(){
    var result=cats.slice();
    var names={xiaomi:"Xiaomi",redmi:"Redmi",poco:"POCO",playstation:"PlayStation",xbox:"Xbox",nintendo:"Nintendo"};
    items.forEach(function(x){
      if(!activeItem(x)) return;
      var key=categoryOf(x);
      if(key==="other" || result.some(function(c){return c[0]===key;})) return;
      var display=names[key];
       if(!display){
         var brand=String(x.Brand||"").trim();
         var group=String(x.Category||"").trim();
         display=[brand,group].filter(Boolean).join(" ") || String(x.Model||key);
       }
       result.push([key,display,"Azonnali \u00E1raj\u00E1nlat"]);
    });
    return result;
  }


  // A Google Sheets Brand / Category / Model mezoi alapjan felepitett valaszto.
  // A jelenlegi ar- es ajanlatkuldesi logika valtozatlan marad.
  function deviceGroupOf(x){
    var b=norm(x.Brand), c=norm(x.Category), m=norm(x.Model);
    if(/playstation|xbox|nintendo|switch|(^| )ps[45]($| )/.test(b+" "+c+" "+m)) return "console";
    if(/watch|ora|smartwatch|wearable/.test(b+" "+c+" "+m)) return "watch";
    if(/ipad|tablet|galaxy tab|(^| )pad( |$)|tab s/.test(b+" "+c+" "+m)) return "tablet";
    return "phone";
  }
  function brandOf(x){
    var b=norm(x.Brand), m=norm(x.Model), g=deviceGroupOf(x);
    if(g==="console"){
      if(/xbox|microsoft/.test(b+" "+m)) return "Xbox";
      if(/nintendo|switch/.test(b+" "+m)) return "Nintendo";
      return "PlayStation";
    }
    if(/iphone|ipad|apple|watch/.test(b) || /iphone|ipad|apple watch/.test(m)) return "Apple";
    if(/samsung|galaxy/.test(b+" "+m)) return "Samsung";
    if(/xiaomi|redmi|poco/.test(b+" "+m)) return "Xiaomi";
    if(/honor/.test(b+" "+m)) return "HONOR";
    if(/huawei/.test(b+" "+m)) return "Huawei";
    return String(x.Brand||"Egyeb").trim();
  }
  function familyOf(x){
    var c=String(x.Category||"").trim(), m=norm(x.Model), b=brandOf(x), g=deviceGroupOf(x);
    if(g==="console") return c && !/^(console|konzol|jatekkonzol)$/i.test(c) ? c : b;
    if(b==="Apple") return g==="watch" ? "Apple Watch" : g==="tablet" ? "iPad" : "iPhone";
    if(b==="Samsung"){
      if(/galaxy s/.test(m)) return "Galaxy S";
      if(/galaxy a/.test(m)) return "Galaxy A";
      if(/galaxy z/.test(m)) return "Galaxy Z";
      if(/galaxy note/.test(m)) return "Galaxy Note";
    }
    if(b==="Xiaomi"){
      if(/redmi/.test(norm(c)+" "+m)) return "Redmi";
      if(/poco/.test(norm(c)+" "+m)) return "POCO";
      return "Xiaomi";
    }
    if(b==="HONOR"){
      if(/magic/.test(norm(c)+" "+m)) return "Magic";
      return c && norm(c)!=="honor" ? c : "HONOR";
    }
    return c || b;
  }
  function navItems(){
    return items.filter(activeItem).filter(function(x){
      return !state.deviceGroup || deviceGroupOf(x)===state.deviceGroup;
    });
  }
  function distinctValues(list,fn){return uniq(list.map(fn)).sort(function(a,b){return a.localeCompare(b,"hu");});}
  function renderHierarchy(){
    var html='', vals=[], label='';
    if(state.navStage===0){
      label="Mit szeretn\u00E9l eladni?";
      var categoryImages = {
  phone: "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Zold_hatter_elott_bemutatott_premium_okostelefonok.png?v=1793287811",
  tablet: "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Elegans_zold_technologia_bemutato.png?v=1793287782",
  watch: "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Premium_zold_technologia_okosoraval.png?v=1793287782",
  console: "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/PlayStation_5_zold_modern_studiokompozicioban.png?v=1793287781"
};
      var types=[["phone","Mobiltelefon","Tel."],["tablet","Tablet","Tab."],["watch","Okos\u00F3ra","Ora"],["console","J\u00E1t\u00E9kkonzol","Game"]];
      vals=types.filter(function(t){return items.some(function(x){return activeItem(x)&&deviceGroupOf(x)===t[0];});});
      html=vals.map(function(t){
  return card(
    t[0],
    t[1],
    "Válassz készüléktípust",
    false,
    categoryImages[t[0]] || t[2],
    false
  );
}).join("");
    }else if(state.navStage===1){
  label="Válassz márkát";

  var brandImages = {
    "Apple": "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Apple_logo_black.svg?v=1793289241",
    "Samsung": "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/samsung-logo.webp?v=1772392101",
    "Xiaomi": "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Xiaomi-logo.jpg?v=1743245432",
    "HONOR": "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/honor.jpg?v=1793289381"
  };

  vals=distinctValues(navItems(),brandOf);

  html=vals.map(function(v){
    return card(
      v,
      v,
      "Márka kiválasztása",
      false,
      brandImages[v] || v.substring(0,2),
      false
    );
  }).join("");
    }else{
      label="V\u00E1lassz sz\u00E9ri\u00E1t";
      vals=distinctValues(navItems().filter(function(x){return brandOf(x)===state.brandName;}),familyOf);
      html=vals.map(function(v){return card(v,v,"Sz\u00E9ria kiv\u00E1laszt\u00E1sa",false,v.substring(0,2),false);}).join("");
    }
    var header='<div class="bb-hierarchy-heading"><strong>'+esc(label)+'</strong></div>';
    var back=state.navStage>0?'<button type="button" class="bb-more" id="bbHierarchyBack" style="margin-bottom:16px">\u2190 Vissza</button>':'';
    $("bbStepContent").innerHTML=header+back+'<div class="bb-card-grid">'+(html||'<div class="bb-empty">Nincs akt\u00EDv, be\u00E1razott k\u00E9sz\u00FCl\u00E9k ebben a kateg\u00F3ri\u00E1ban.</div>')+'</div>';
    var backBtn=$("bbHierarchyBack");
    if(backBtn) backBtn.onclick=function(){state.navStage--;render();};
    wire(function(v){
      if(state.navStage===0){state.deviceGroup=v;state.navStage=1;}
      else if(state.navStage===1){state.brandName=v;state.navStage=2;}
      else{
        state.familyName=v;
        var first=navItems().find(function(x){return brandOf(x)===state.brandName&&familyOf(x)===v;});
        state.category=first?categoryOf(first):"other";
        if(state.deviceGroup==="console"){
          $("bbStepContent").innerHTML='<div class="bb-empty">A konzolok k\u00FCl\u00F6n \u00E1llapotfelm\u00E9r\u00E9se m\u00E9g fejleszt\u00E9s alatt \u00E1ll. A telefonos felv\u00E1s\u00E1rl\u00E1s m\u00E1r tesztelhet\u0151.</div><button type="button" class="bb-more" id="bbConsoleBack">Vissza</button>';
          $("bbConsoleBack").onclick=function(){state.navStage=1;render();};
          return;
        }
        state.step=1;
        state.series="all";
        state.model="";
        state.storage="";
        visible=12;
      }
      render();
    });
  }

  function itemList(){
    return navItems().filter(function(x){
      return (!state.brandName || brandOf(x)===state.brandName) &&
        (!state.familyName || familyOf(x)===state.familyName);
    });
  }

  function seriesOk(m){

  if(state.series === "all"){
    return true;
  }

  var model = String(m || "");

  if(state.category === "iphone"){
    return model.indexOf("iPhone " + state.series) > -1;
  }

  if(state.category === "galaxy-s"){
    return model.toLowerCase().indexOf(
      ("Galaxy " + state.series).toLowerCase()
    ) > -1;
  }

  if(state.category === "galaxy-a"){
    return model.toLowerCase().indexOf(
      ("Galaxy " + state.series).toLowerCase()
    ) > -1;
  }

  return true;
}


  function models(){

    return uniq(

      itemList().map(function(x){
        return x.Model;
      })

    ).filter(seriesOk);
  }


  function storages(){

    return uniq(

      items.filter(function(x){

        return (
          x.Model===state.model &&
          categoryOf(x)===state.category &&
          activeItem(x)
        );

      }).map(function(x){

        return String(x.StorageGB);

      })

    );
  }


  function selected(){

    return items.find(function(x){

      return (
        x.Model===state.model &&
        itemList().indexOf(x)!==-1 &&
        String(x.StorageGB)===String(state.storage)
      );

    });
  }


  function amount(item,key){

    var v=item&&item[key];

    if(v==null){
      return 0;
    }

    if(String(v).toLowerCase()==="x"){
      return "X";
    }

    var n=Number(
      String(v)
        .replace("\u2212","-")
        .replace(/[^0-9-]/g,"")
    );

    return isFinite(n)
      ? Math.abs(n)
      : 0;
  }


  function label(key){

    for(var i=0;i<conds.length;i++){

      for(var j=0;j<conds[i][2].length;j++){

        if(conds[i][2][j][0]===key){
          return conds[i][2][j][1];
        }

      }
    }

    return "";
  }


  function akkuKey(p){

    p=Number(p||0);

    if(p>=85){
      return "D_Akku_Jo_Ft";
    }

    if(p>=80){
      return "D_Akku_Elfogadhato_Ft";
    }

    return "D_Akku_Cseres_Ft";
  }


  function akkuLabel(p){

    p=Number(p||0);

    if(p>=85){
      return "J\u00F3";
    }

    if(p>=80){
      return "Elfogadhat\u00F3";
    }

    return "Cser\u00E9s";
  }


  function card(
    value,
    title,
    sub,
    active,
    icon,
    disabled
  ){

    var iconHtml = "";

    if(
      icon &&
      (
        icon.indexOf("https://") === 0 ||
        icon.indexOf("http://") === 0
      )
    ){

      iconHtml =
        '<img class="bb-choice-device-img" '+
        'src="'+esc(icon)+'" '+
        'alt="'+esc(title)+'" '+
        'loading="lazy">';

    }else if(
      icon &&
      String(icon).trim().charAt(0) === "<"
    ){

      iconHtml = icon;

    }else{

      iconHtml = esc(icon || "Tel.");

    }

    return (
      '<button type="button" class="bb-choice '+
      (active?'active ':'')+
      (disabled?'disabled ':'')+
      '" data-value="'+esc(value)+'">'+

        '<span class="bb-choice-check" aria-hidden="true">\u2713</span>'+

        '<span class="bb-choice-icon">'+
          iconHtml+
        '</span>'+

        '<span class="bb-choice-copy">'+
          '<span class="bb-choice-title">'+esc(title)+'</span>'+
          '<span class="bb-choice-sub">'+esc(sub || "")+'</span>'+
        '</span>'+

      '</button>'
    );
  }


  function imgFor(m){

    if(imgs[m]){
      return imgs[m];
    }

    var low=String(m||"").toLowerCase();

    for(var k in imgs){

      if(k.toLowerCase()===low){
        return imgs[k];
      }
    }

    if(low.indexOf("iphone 16")>-1){
      return imgs["iPhone 16"];
    }

    if(low.indexOf("iphone 15")>-1){
      return imgs["iPhone 15"];
    }

    if(low.indexOf("iphone 14")>-1){
      return imgs["iPhone 14"];
    }

    if(low.indexOf("iphone 13")>-1){
      return imgs["iPhone 13"];
    }

    if(low.indexOf("iphone 12")>-1){
      return imgs["iPhone 12"];
    }

    if(low.indexOf("iphone 11")>-1){
      return imgs["iPhone 11"];
    }

    if(low.indexOf("iphone x")>-1){
      return imgs["iPhone X"];
    }

    if(low.indexOf("iphone 8")>-1){
      return imgs["iPhone 8"];
    }

    return "";
  }


  function conditionIcon(group, key){

    var g = String(group || "").toLowerCase();
    var k = String(key || "").toLowerCase();


    function svg(inner){

      return (
        '<span class="bb-state-visual">'+

          '<svg viewBox="0 0 100 100" aria-hidden="true">'+
            inner+
          '</svg>'+

        '</span>'
      );
    }


    /* ================================
       KIJELZ\u0150
    ================================ */

    if(g === "kijelzo"){

      if(k.indexOf("karcmentes") >= 0){

        return svg(
          '<rect x="20" y="10" width="60" height="80" rx="12" class="v-device"/>'+
          '<rect x="25" y="16" width="50" height="66" rx="8" class="v-screen"/>'+
          '<path d="M32 28 L66 20" class="v-shine"/>'+
          '<circle cx="50" cy="86" r="2" class="v-detail"/>'
        );
      }


      if(
        k.indexOf("minkarc") >= 0 ||
        k.indexOf("mini") >= 0
      ){

        return svg(
          '<rect x="20" y="10" width="60" height="80" rx="12" class="v-device"/>'+
          '<rect x="25" y="16" width="50" height="66" rx="8" class="v-screen"/>'+
          '<path d="M36 42 L51 38" class="v-scratch-light"/>'+
          '<path d="M48 58 L62 53" class="v-scratch-light"/>'+
          '<circle cx="50" cy="86" r="2" class="v-detail"/>'
        );
      }


      if(
        k.indexOf("karcos") >= 0 ||
        k.indexOf("kopott") >= 0
      ){

        return svg(
          '<rect x="20" y="10" width="60" height="80" rx="12" class="v-device"/>'+
          '<rect x="25" y="16" width="50" height="66" rx="8" class="v-screen"/>'+
          '<path d="M31 37 L66 29" class="v-scratch"/>'+
          '<path d="M35 57 L67 46" class="v-scratch"/>'+
          '<path d="M30 68 L59 60" class="v-scratch"/>'+
          '<circle cx="50" cy="86" r="2" class="v-detail"/>'
        );
      }


      if(
        k.indexOf("torott") >= 0 ||
        k.indexOf("t\u00F6r\u00F6tt") >= 0
      ){

        return svg(
          '<rect x="20" y="10" width="60" height="80" rx="12" class="v-device"/>'+
          '<rect x="25" y="16" width="50" height="66" rx="8" class="v-screen"/>'+
          '<path d="M68 22 L53 40 L62 49 L43 58 L55 80" class="v-crack"/>'+
          '<path d="M53 40 L38 29 M53 40 L73 44 M43 58 L29 52" class="v-crack"/>'+
          '<circle cx="50" cy="86" r="2" class="v-detail"/>'
        );
      }
    }


    /* ================================
       KERET
    ================================ */

    if(g === "keret"){

      if(
        k.indexOf("szep") >= 0 ||
        k.indexOf("sz\u00E9p") >= 0
      ){

        return svg(
          '<rect x="24" y="10" width="52" height="80" rx="14" class="v-frame"/>'+
          '<rect x="29" y="16" width="42" height="67" rx="9" class="v-screen-soft"/>'+
          '<path d="M27 31 L27 46" class="v-button"/>'
        );
      }


      if(
        k.indexOf("karcos") >= 0 ||
        k.indexOf("kopott") >= 0
      ){

        return svg(
          '<rect x="24" y="10" width="52" height="80" rx="14" class="v-frame"/>'+
          '<rect x="29" y="16" width="42" height="67" rx="9" class="v-screen-soft"/>'+
          '<path d="M25 30 L31 34 M24 54 L31 57 M67 68 L75 64" class="v-scratch"/>'
        );
      }


      if(
        k.indexOf("serult") >= 0 ||
        k.indexOf("s\u00E9r\u00FClt") >= 0
      ){

        return svg(
          '<path d="M30 10 H68 Q77 10 76 22 L73 39 L79 48 L74 62 L75 78 Q75 90 63 90 H31 Q24 90 24 80 V22 Q24 10 30 10Z" class="v-frame"/>'+
          '<path d="M73 39 L65 43 L73 49" class="v-damage"/>'+
          '<path d="M26 65 L34 61" class="v-damage"/>'
        );
      }
    }


    /* ================================
       H\u00C1TLAP
    ================================ */

    if(g === "hatlap"){

      if(
        k.indexOf("szep") >= 0 ||
        k.indexOf("sz\u00E9p") >= 0
      ){

        return svg(
          '<rect x="22" y="10" width="56" height="80" rx="12" class="v-back"/>'+
          '<circle cx="36" cy="27" r="8" class="v-camera"/>'+
          '<circle cx="54" cy="27" r="8" class="v-camera"/>'+
          '<circle cx="36" cy="45" r="8" class="v-camera"/>'+
          '<circle cx="57" cy="49" r="3" class="v-flash"/>'
        );
      }


      if(k.indexOf("karcos") >= 0){

        return svg(
          '<rect x="22" y="10" width="56" height="80" rx="12" class="v-back"/>'+
          '<circle cx="36" cy="27" r="8" class="v-camera"/>'+
          '<circle cx="54" cy="27" r="8" class="v-camera"/>'+
          '<path d="M31 61 L67 51 M33 70 L62 64" class="v-scratch"/>'
        );
      }


      if(
        k.indexOf("repedt") >= 0 ||
        k.indexOf("torott") >= 0
      ){

        return svg(
          '<rect x="22" y="10" width="56" height="80" rx="12" class="v-back"/>'+
          '<circle cx="36" cy="27" r="8" class="v-camera"/>'+
          '<circle cx="54" cy="27" r="8" class="v-camera"/>'+
          '<path d="M62 43 L50 56 L58 64 L44 77" class="v-crack"/>'+
          '<path d="M50 56 L38 49 M58 64 L70 69" class="v-crack"/>'
        );
      }
    }


    /* ================================
       BE\u00C9G\u00C9S
    ================================ */

    if(g === "beeges"){

      if(k.indexOf("nincs") >= 0){

        return svg(
          '<rect x="18" y="18" width="64" height="64" rx="10" class="v-device"/>'+
          '<rect x="23" y="23" width="54" height="54" rx="7" class="v-screen"/>'+
          '<path d="M31 37 L67 29" class="v-shine"/>'
        );
      }


      return svg(
        '<rect x="18" y="18" width="64" height="64" rx="10" class="v-device"/>'+
        '<rect x="23" y="23" width="54" height="54" rx="7" class="v-screen"/>'+
        '<rect x="33" y="32" width="34" height="25" rx="5" class="v-burn"/>'+
        '<circle cx="42" cy="67" r="7" class="v-burn"/>'
      );
    }


    /* ================================
       PIXELHIBA
    ================================ */

    if(g === "pixel"){

      if(k.indexOf("nincs") >= 0){

        return svg(
          '<rect x="18" y="18" width="64" height="64" rx="10" class="v-device"/>'+
          '<rect x="23" y="23" width="54" height="54" rx="7" class="v-screen"/>'
        );
      }


      return svg(
        '<rect x="18" y="18" width="64" height="64" rx="10" class="v-device"/>'+
        '<rect x="23" y="23" width="54" height="54" rx="7" class="v-screen"/>'+
        '<circle cx="57" cy="43" r="5" class="v-pixel"/>'
      );
    }


    /* ================================
       TARTOZ\u00C9K
    ================================ */

    if(g === "tartozek"){

      if(
        k.indexOf("megvan") >= 0 ||
        k.indexOf("gyari") >= 0
      ){

        return svg(
          '<rect x="21" y="30" width="25" height="32" rx="6" class="v-accessory"/>'+
          '<path d="M28 30 V20 M39 30 V20" class="v-cable"/>'+
          '<path d="M53 63 C67 63 72 51 65 42 C58 34 49 39 52 47 C54 53 64 53 70 48" class="v-cable"/>'
        );
      }


      if(
        k.indexOf("utangyartott") >= 0 ||
        k.indexOf("k\u00E1bel") >= 0 ||
        k.indexOf("kabel") >= 0
      ){

        return svg(
          '<path d="M24 52 C25 28 49 26 50 46 C51 66 75 67 76 44" class="v-cable"/>'+
          '<rect x="18" y="48" width="10" height="9" rx="2" class="v-accessory"/>'+
          '<rect x="73" y="39" width="9" height="12" rx="2" class="v-accessory"/>'
        );
      }


      return svg(
        '<circle cx="50" cy="50" r="30" class="v-none"/>'+
        '<path d="M30 30 L70 70" class="v-none-line"/>'+
        '<path d="M39 53 C42 38 60 38 63 51" class="v-cable"/>'
      );
    }


    /* ================================
       FALLBACK
    ================================ */

    return svg(
      '<circle cx="50" cy="50" r="24" class="v-fallback"/>'+
      '<path d="M50 37 V52 M50 62 V64" class="v-question"/>'
    );
  }


  function wire(fn){

    Array.prototype.forEach.call(
      $("bbStepContent").querySelectorAll("[data-value]"),
      function(b){

        b.onclick=function(){
          fn(this.getAttribute("data-value"));
        };

      }
    );
  }


  function renderTop(){

    $("bbStepper").innerHTML = steps.map(function(s,i){

      var marker = i < state.step
        ? "\u2713"
        : (i+1);

      return (
        '<button type="button" '+
        'class="bb-step '+
        (i===state.step?'active ':'')+
        (i<state.step?'done':'')+
        '" data-step="'+i+'" '+
        (i>state.step?'disabled':'')+'>'+

          '<span>'+marker+'</span>'+
          '<strong>'+s+'</strong>'+

        '</button>'
      );

    }).join("");


    Array.prototype.forEach.call(
      $("bbStepper").querySelectorAll("[data-step]"),
      function(b){

        b.onclick=function(){

          var target=Number(
            this.getAttribute("data-step")
          );

          if(target<=state.step){

            state.step=target;

            if(state.step!==3){
              state.condition=0;
            }

            render();
          }
        };

      }
    );


    var pills=[];


    if(state.category){

      pills.push(
        state.category==="iphone"
          ? "Apple iPhone"
          : state.category
      );

    }


    if(state.series!=="all"){

      pills.push(
        state.series==="old"
          ? "R\u00E9gebbi"
          : "iPhone "+state.series
      );

    }


    if(state.model){
      pills.push(state.model);
    }


    if(state.storage){
      pills.push(state.storage+" GB");
    }


    $("bbSelectedStrip").innerHTML = pills.length

      ? pills.map(function(p){

          return (
            '<span class="bb-pill">\u2713 '+
            esc(p)+
            '</span>'
          );

        }).join("")

      : '<span class="bb-selected-help">'+
        'A kiv\u00E1lasztott adatok itt jelennek meg.'+
        '</span>';


    /* =======================================
       SAMSUNG \u00C1LLAPOT-SZ\u00C1ML\u00C1L\u00D3 JAV\u00CDT\u00C1S
    ======================================= */

    var isSamsung = skipsBattery();


    var conditionNumber =
      isSamsung
        ? state.condition
        : (state.condition + 1);


    var conditionTotal =
      isSamsung
        ? (conds.length - 1)
        : conds.length;


    $("bbStepKicker").textContent = state.step===3

      ? (
          "4. l\u00E9p\u00E9s \u2022 "+
          conditionNumber+
          " / "+
          conditionTotal
        )

      : (
          (state.step+1)+
          ". l\u00E9p\u00E9s \u2022 5-b\u0151l"
        );


    $("bbStepTitle").textContent =
      state.step===3
        ? conds[state.condition][1]
        : steps[state.step];


    $("bbNavCount").textContent = state.step===3

      ? (
          "\u00C1llapot "+
          conditionNumber+
          " / "+
          conditionTotal
        )

      : (
          (state.step+1)+
          " / 5"
        );


    $("bbBack").style.visibility =
      (state.step===0 && state.navStage===0)
        ? "hidden"
        : "visible";


    $("bbNext").disabled =
      (state.step===0) ||
      (
        state.step===1 &&
        !state.model
      )
      ||
      (
        state.step===2 &&
        !state.storage
      );


    $("bbNext").textContent =

      state.step===4

        ? "\u00DAjrakezd\u00E9s"

        : (
            state.step===3 &&
            state.condition===conds.length-1

              ? "Aj\u00E1nlat megtekint\u00E9se"

              : "Tov\u00E1bb"
          );
  }


  function renderCategory(){

    $("bbStepContent").innerHTML =

      '<div class="bb-card-grid">'+

      allCategories().map(function(c){

        var ok = items.some(function(x){

          return (
            categoryOf(x) === c[0] &&
            activeItem(x)
          );

        });


        var subtitle =
          isConsoleCategory(c[0])
            ? "\u00C1llapotfelm\u00E9r\u00E9s fejleszt\u00E9s alatt"
            : (ok ? "Azonnali \u00E1raj\u00E1nlat" : "Hamarosan");


        var categoryImages = {

          "iphone":
            "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0560.webp?v=1770413286",

          "watch":
            "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/IMG_0570.jpg?v=1770413286",

          "galaxy-a":
            "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/pixelcut_12_96cf83c0-cb59-4e52-ab21-716d295b149b.png?v=1742485444",

          "galaxy-s":
            "https://cdn.shopify.com/s/files/1/0862/7801/3256/files/Galaxy_S24_Ultra_-_Titanium_Grey_-_Overlap_Trans-cropped.webp?v=1742406090"

        };


        var icon =
          categoryImages[c[0]] ||
          (
            c[0] === "ipad"
              ? "A"
              : "Tel."
          );


        return card(
          c[0],
          c[1],
          subtitle,
          state.category === c[0],
          icon,
          !ok || isConsoleCategory(c[0])
        );

      }).join("")+

      '</div>';


    wire(function(v){

      state.category = v;

      state.model = "";

      state.storage = "";

      state.series = "all";

      state.step = 1;

      render();

    });
  }


  function renderModels(){

    var ms=models();

    var shown=ms.slice(0,visible);


    var html=

      '<input '+
      'class="bb-search" '+
      'id="bbModelSearchWizard" '+
      'placeholder="Keres\u00E9s (pl. iPhone 13, Pro Max...)">';


    html+=

      '<div class="bb-series-mini">'+

      getSeriesList().map(function(s){

        return (
          '<button type="button" '+
          'class="bb-series-mini-btn '+
          (state.series===s[0]?'active':'')+
          '" data-series="'+s[0]+'">'+
          s[1]+
          '</button>'
        );

      }).join("")+

      '</div>';


    html+=
      '<p class="bb-model-pricing-note" style="text-align:center;color:#667068;font-size:12px;line-height:1.45;margin:0 0 12px;">'+
      'Az \u201eAk\u00e1r\u201d \u00e1rak hib\u00e1tlan \u00e1llapot\u00fa k\u00e9sz\u00fcl\u00e9kekre vonatkoznak, t\u00e1rhelyt\u0151l f\u00fcgg\u0151en.</p>' +

      '<div class="bb-card-grid bb-model-grid" id="bbModelCards">'+

      (
        shown.length

          ? shown.map(modelCard).join("")

          : (
              '<div class="bb-empty">'+
              'Nem tal\u00E1lhat\u00F3 modell. '+
              'Bet\u00F6lt\u00F6tt \u00E1rlista sorok: '+
              items.length+
              '</div>'
            )
      )+

      '</div>';


    if(ms.length>visible){

      html+=
        '<div class="bb-more-wrap">'+
          '<button type="button" class="bb-more" id="bbMoreModels">'+
            'Tov\u00E1bbi modellek'+
          '</button>'+
        '</div>';

    }


    $("bbStepContent").innerHTML=html;


    Array.prototype.forEach.call(
      document.querySelectorAll(".bb-series-mini-btn"),
      function(b){

        b.onclick=function(){

          state.series=this.getAttribute("data-series");

          state.model="";

          state.storage="";

          visible=12;

          render();

        };

      }
    );


    wire(function(v){

      state.model=v;

      state.storage="";

      state.step=2;

      render();

    });


    var more=$("bbMoreModels");


    if(more){

      more.onclick=function(){

        visible+=12;

        render();

      };
    }


    var search=$("bbModelSearchWizard");


    if(search){

      search.oninput=function(){

        var q=this.value.toLowerCase();


        $("bbModelCards").innerHTML =

          ms.filter(function(m){

            return (
              m.toLowerCase().indexOf(q)>-1
            );

          })

          .slice(0,24)

          .map(modelCard)

          .join("")

          ||

          '<div class="bb-empty">Nincs tal\u00E1lat.</div>';


        wire(function(v){

          state.model=v;

          state.storage="";

          state.step=2;

          render();

        });

      };
    }
  }


  function modelCard(m){

    var src=imgFor(m);

    var img=src
      ? '<img src="'+esc(src)+'" alt="'+esc(m)+'" loading="lazy">'
      : "Tel.";

    // A legmagasabb AKTIV tarhelyvaltozat alaparaval hirdetunk.
    // Az allapot szerinti levonasok csak a kesobbi kalkulacioban jonnek.
    var maxPrice=0;
    itemList().forEach(function(x){
      if(String(x.Model) !== String(m)) return;
      var price=Number(x.BasePriceFt || 0);
      if(isFinite(price) && price > maxPrice) maxPrice=price;
    });

    var result=card(
      m,
      m,
      "",
      state.model===m,
      img,
      false
    );

    if(maxPrice>0){
      var priceHtml='<span class="bb-model-max-price" style="display:block;color:#21834b;font-weight:700;margin-top:5px;">'+
        'Ak\u00E1r '+esc(fmt(maxPrice))+'</span>'+
        '';
      result=result.replace('</span></span></button>',priceHtml+'</span></span></button>');
    }

    return result;
  }


  function renderStorage(){
if(state.category === "watch"){
  state.storage = 0;
  state.step = 3;
  state.condition = 0;
  render();
  return;
}
    $("bbStepContent").innerHTML =

      '<div class="bb-card-grid">'+

      storages().map(function(s){

        return card(
          s,
          s+" GB",
          "T\u00E1rhely kiv\u00E1laszt\u00E1sa",
          String(state.storage)===String(s),
          "GB",
          false
        );

      }).join("")+

      '</div>';


    wire(function(v){

      state.storage=v;

      state.step=3;

      state.condition=0;

      render();

    });
  }


  function renderCondition(){

    /* ===========================================
       SAMSUNGN\u00C1L AKKUMUL\u00C1TOR L\u00C9P\u00C9S KIHAGY\u00C1SA
    =========================================== */

    if(
      skipsBattery()
      &&
      state.condition === 0
    ){

      state.condition = 1;

    }


    var c=conds[state.condition];


    if(c[0]==="akku"){

      state.picks.akku=
        akkuKey(state.akkuPercent);


      var batteryTone =

        state.akkuPercent < 70

          ? "is-bad"

          : (
              state.akkuPercent < 80
                ? "is-warn"
                : "is-good"
            );


      $("bbStepContent").innerHTML =

        '<div class="bb-akku-panel">'+

          '<div class="bb-akku-top">'+

            '<div>'+

              '<span class="bb-akku-caption">'+
                'Akkumul\u00E1tor \u00E1llapota'+
              '</span>'+

              '<strong id="bbAkkuPercentText">'+
                state.akkuPercent+
                '%'+
              '</strong>'+

            '</div>'+

            '<span id="bbAkkuStatus" '+
            'class="bb-akku-status '+batteryTone+'">'+

              akkuLabel(state.akkuPercent)+

            '</span>'+

          '</div>'+


          '<div class="bb-battery-wrap">'+

            '<div id="bbBattery" '+
            'class="bb-battery '+batteryTone+'" '+
            'aria-hidden="true">'+

              '<div id="bbBatteryFill" '+
              'class="bb-battery-fill" '+
              'style="width:'+state.akkuPercent+'%;">'+
              '</div>'+

            '</div>'+


            '<div id="bbBatteryPercent" '+
            'class="bb-battery-percent">'+

              state.akkuPercent+
              '%'+

            '</div>'+

          '</div>'+


          '<input '+
          'id="bbAkkuSlider" '+
          'class="bb-akku-slider '+batteryTone+'" '+
          'type="range" '+
          'min="0" '+
          'max="100" '+
          'step="1" '+
          'value="'+state.akkuPercent+'">'+


          '<div class="bb-akku-scale">'+
            '<span>0%</span>'+
            '<span>70%</span>'+
            '<span>80%</span>'+
            '<span>100%</span>'+
          '</div>'+


          '<div class="bb-akku-help">'+

            '\u00C1ll\u00EDtsd be a k\u00E9sz\u00FCl\u00E9k akkumul\u00E1tor \u00E1llapot\u00E1t. '+
            'Az akkumul\u00E1tor bels\u0151 sz\u00EDne 80% alatt s\u00E1rg\u00E1ra, '+
            '70% alatt pirosra v\u00E1lt.'+

          '</div>'+

        '</div>';


      $("bbAkkuSlider").oninput=function(){

        state.akkuPercent=
          Number(this.value);


        state.picks.akku=
          akkuKey(state.akkuPercent);


        var tone =

          state.akkuPercent < 70

            ? "is-bad"

            : (
                state.akkuPercent < 80
                  ? "is-warn"
                  : "is-good"
              );


        var percent =
          state.akkuPercent+"%";


        $("bbAkkuPercentText").textContent=
          percent;


        $("bbBatteryPercent").textContent=
          percent;


        $("bbBatteryFill").style.width=
          percent;


        $("bbAkkuStatus").textContent=
          akkuLabel(state.akkuPercent);


        $("bbAkkuStatus").className=
          "bb-akku-status "+tone;


        $("bbBattery").className=
          "bb-battery "+tone;


        this.className=
          "bb-akku-slider "+tone;


        calc();

      };


      return;
    }


    $("bbStepContent").innerHTML =

      '<div class="bb-card-grid">'+

      c[2].map(function(o){

        return card(
          o[0],
          o[1],
          o[2],
          state.picks[c[0]]===o[0],
          conditionIcon(c[0], o[0]),
          false
        );

      }).join("")+

      '</div>';


    wire(function(v){

      state.picks[c[0]]=v;


      if(state.condition<conds.length-1){

        state.condition++;

      }else{

        state.step=4;

      }


      render();

    });
  }


  function renderOffer(){

    var it=selected();


    var html=

      '<div class="bb-final-panel">'+

        '<div class="bb-final-icon">\u2713</div>'+

        '<p class="bb-final-eyebrow">'+
          'AZ AJ\u00C1NLAT ELK\u00C9SZ\u00DCLT'+
        '</p>'+


        '<h3>'+
          'K\u00E9red a v\u00E1rhat\u00F3 felv\u00E1s\u00E1rl\u00E1si \u00E1rat?'+
        '</h3>'+


        '<p class="bb-final-device">'+

          (
            it

              ? (
                  esc(it.Model)+
                  ' \u2022 '+
                  esc(it.StorageGB)+
                  ' GB'
                )

              : ''
          )+

        '</p>'+


        '<p class="bb-final-note">'+

          'Add meg az e-mail c\u00EDmed, \u00E9s azonnal megmutatjuk '+
          'a v\u00E1rhat\u00F3 felv\u00E1s\u00E1rl\u00E1si \u00E1rat. '+
          'Az aj\u00E1nlatot e-mailben is elk\u00FCldj\u00FCk.'+

        '</p>'+


        '<div class="bb-offer-email-box">'+

          '<input '+
            'type="email" '+
            'id="bbOfferEmail" '+
            'class="bb-search" '+
            'placeholder="E-mail c\u00EDmed" '+
            'autocomplete="email"'+
          '>'+


          '<button '+
            'type="button" '+
            'class="bb-final-action" '+
            'id="bbSendOffer"'+
          '>'+

            'Aj\u00E1nlat megtekint\u00E9se \u00E9s elk\u00FCld\u00E9se'+

          '</button>'+


          '<div id="bbOfferMessage" style="margin-top:12px;"></div>'+

        '</div>'+


        '<div id="bbOfferResult" style="display:none;">'+

          '<div class="bb-final-price" id="bbFinalPrice">'+
            '\u2014 Ft'+
          '</div>'+


          '<div class="bb-final-benefits">'+

            '<span>\u2713 Azonnali k\u00E9szp\u00E9nz</span>'+

            '<span>\u2713 Gyors helysz\u00EDni bevizsg\u00E1l\u00E1s</span>'+

            '<span>\u2713 Etele Pl\u00E1za \u2022 f\u00F6ldszint</span>'+

          '</div>'+


          '<p class="bb-final-note">'+

            'A megjelen\u00EDtett \u00F6sszeg t\u00E1j\u00E9koztat\u00F3 jelleg\u0171. '+

            'A v\u00E9gleges aj\u00E1nlatot az EcoMobil Etele \u00FCzlet\u00E9ben, '+

            'gyors helysz\u00EDni bevizsg\u00E1l\u00E1s ut\u00E1n adjuk meg.'+

          '</p>'+


          '<div class="bb-final-actions">'+

            '<a class="bb-final-action" href="tel:+36705525552">'+
              'H\u00EDv\u00E1s most'+
            '</a>'+


            '<button type="button" '+
            'class="bb-final-action secondary" '+
            'id="bbRouteBtn">'+

              '\u00DAtvonal az \u00FCzlethez'+

            '</button>'+

          '</div>'+

        '</div>'+

      '</div>';


    $("bbStepContent").innerHTML=html;


    var sendBtn=$("bbSendOffer");


    if(sendBtn){

      sendBtn.onclick=sendOffer;

    }


    var routeBtn=$("bbRouteBtn");


    if(routeBtn){

      routeBtn.onclick=openRoute;

    }
  }


  function getCurrentOfferData(){

    var it=selected();


    if(!it){

      return null;

    }


    var sum=0;

    var keys=Object.keys(state.picks);


    for(var i=0;i<keys.length;i++){

      if(keys[i] === "akku" && skipsBattery()) continue;

      var d=amount(
        it,
        state.picks[keys[i]]
      );


      if(d==="X"){

        return {
          custom:true
        };

      }


      sum+=d;
    }


    var offer=Math.max(
      0,
      Number(it.BasePriceFt||0)-sum
    );


    var condition=keys.map(function(k){

      if(k === "akku" && skipsBattery()) return "";

      return k==="akku"

        ? (
            "Akkumul\u00E1tor: "+
            state.akkuPercent+
            "% ("+
            akkuLabel(state.akkuPercent)+
            ")"
          )

        : label(state.picks[k]);

    })

    .filter(Boolean)

    .join(" \u2022 ");


    return {

      custom:false,

      model:it.Model,

      storage:it.StorageGB,

      battery:state.akkuPercent+"%",

      condition:condition,

      offer:offer

    };
  }


  function sendOffer(){

    var emailInput=$("bbOfferEmail");

    var btn=$("bbSendOffer");

    var message=$("bbOfferMessage");

    var result=$("bbOfferResult");


    if(!emailInput || !btn){

      return;

    }


    var email=
      String(emailInput.value||"").trim();


    if(
      !email ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    ){

      if(message){

        message.innerHTML=
          '<span style="color:#b42318;font-weight:700;">'+
            'K\u00E9rlek, adj meg egy \u00E9rv\u00E9nyes e-mail c\u00EDmet.'+
          '</span>';

      }


      emailInput.focus();

      return;
    }


    var data=getCurrentOfferData();


    if(!data){

      if(message){

        message.innerHTML=
          '<span style="color:#b42318;font-weight:700;">'+
            'Nem siker\u00FClt elk\u00E9sz\u00EDteni az aj\u00E1nlatot.'+
          '</span>';

      }

      return;
    }


    if(data.custom){

      if(message){

        message.innerHTML=
          '<span style="color:#b42318;font-weight:700;">'+
            'Ehhez az \u00E1llapothoz szem\u00E9lyes bevizsg\u00E1l\u00E1s sz\u00FCks\u00E9ges.'+
          '</span>';

      }

      return;
    }


    btn.disabled=true;

    btn.textContent=
      "Aj\u00E1nlat k\u00FCld\u00E9se\u2026";


    var frameName=
      "ecoOfferFrame";


    var iframe=
      document.getElementById(frameName);


    if(!iframe){

      iframe=
        document.createElement("iframe");


      iframe.name=frameName;

      iframe.id=frameName;

      iframe.style.display="none";


      document.body.appendChild(iframe);
    }


    var form=
      document.createElement("form");


    form.method="POST";

    form.action=ECO_OFFER_ENDPOINT;

    form.target=frameName;

    form.style.display="none";


    var fields={

  action:"create-offer",

  email:email,

  model:data.model,

  storage:data.storage,

  battery:
  (state.category === "galaxy-s" || state.category === "galaxy-a")
    ? ""
    : data.battery,

  condition:data.condition,

  offerPrice:fmt(data.offer),

  offerId:"ECO-"+Date.now()+"-"+Math.floor(1000+Math.random()*9000)

};

var currentOfferId = fields.offerId;

try {
  localStorage.setItem("ecoLastOfferId", currentOfferId);
} catch(e) {
  console.log("Offer ID ment\u00E9se sikertelen:", e);
}


    Object.keys(fields).forEach(function(key){

      var input=
        document.createElement("input");


      input.type="hidden";

      input.name=key;

      input.value=fields[key];


      form.appendChild(input);

    });


    document.body.appendChild(form);

    form.submit();


    setTimeout(function(){

      if(form.parentNode){

        form.parentNode.removeChild(form);

      }

    },1000);


    var finalPrice=$("bbFinalPrice");


    if(finalPrice){

      finalPrice.textContent=
        fmt(data.offer);

    }


    if(result){

      result.style.display="block";

    }
// BEHOZOM A K\u00C9SZ\u00DCL\u00C9KET GOMB
if(result){

  var bringBtn = document.getElementById("ecoBringDeviceBtn");

  if(!bringBtn){

    bringBtn = document.createElement("button");
    bringBtn.id = "ecoBringDeviceBtn";
    bringBtn.type = "button";
    bringBtn.textContent = "\u2713 Behozom a k\u00E9sz\u00FCl\u00E9ket";

    bringBtn.style.cssText =
      "width:100%;" +
      "margin-top:16px;" +
      "padding:15px 20px;" +
      "border:0;" +
      "border-radius:14px;" +
      "background:#047857;" +
      "color:#fff;" +
      "font-size:16px;" +
      "font-weight:800;" +
      "cursor:pointer;";

    result.appendChild(bringBtn);
  }

  bringBtn.onclick = function(){

  bringBtn.disabled = true;
  bringBtn.textContent = "R\u00F6gz\u00EDt\u00E9s...";

  setTimeout(function(){
  updateOfferStatus(currentOfferId, "Behozva");
}, 2000);

  if (typeof rejectBtn !== "undefined" && rejectBtn) {
    rejectBtn.disabled = true;
    rejectBtn.style.opacity = "0.5";
  }

  setTimeout(function(){
    bringBtn.textContent = "\u2713 Jelezted, hogy behozod";
    bringBtn.style.opacity = "0.7";
  }, 800);

};


// ELUTAS\u00CDTOM AZ AJ\u00C1NLATOT GOMB
var rejectBtn = document.getElementById("ecoRejectOfferBtn");

if (!rejectBtn) {

  rejectBtn = document.createElement("button");
  rejectBtn.id = "ecoRejectOfferBtn";
  rejectBtn.type = "button";
  rejectBtn.textContent = "\u2715 Nem k\u00E9rem az aj\u00E1nlatot";

  rejectBtn.style.cssText =
    "width:100%;" +
    "margin-top:10px;" +
    "padding:14px 20px;" +
    "border:1px solid #d8d8d8;" +
    "border-radius:14px;" +
    "background:#ffffff;" +
    "color:#666;" +
    "font-size:15px;" +
    "font-weight:700;" +
    "cursor:pointer;";

}

rejectBtn.onclick = function(){

  rejectBtn.disabled = true;
  rejectBtn.textContent = "R\u00F6gz\u00EDt\u00E9s...";

  updateOfferStatus(currentOfferId, "Elutas\u00EDtotta");

  bringBtn.disabled = true;
  bringBtn.style.opacity = "0.5";

  setTimeout(function(){
    rejectBtn.textContent = "\u2713 Aj\u00E1nlat elutas\u00EDtva";
    rejectBtn.style.opacity = "0.7";
  }, 800);

};



// SAJAT AR AJANLASA - az eredeti ajanlatot nem modositja.
var counterBtn = document.getElementById("ecoCounterOfferBtn");
if (!counterBtn) {
  counterBtn = document.createElement("button");
  counterBtn.id = "ecoCounterOfferBtn";
  counterBtn.type = "button";
  counterBtn.textContent = "💬 Nem ennyiért adnád el? Mondj saját árat!";
 counterBtn.style.cssText = "width:100%;margin-top:14px;padding:19px 20px;border:2px solid #087b45;border-radius:16px;background:linear-gradient(135deg,#087b45,#0e9f63);color:#ffffff;font-size:16px;font-weight:800;cursor:pointer;box-shadow:0 8px 22px rgba(8,123,69,.24);transition:all .25s ease;text-align:center;";
 var counterInfo = document.createElement("div");

counterInfo.style.cssText =
  "margin-top:20px;padding:18px;border-radius:16px;" +
  "background:#eaf7ef;border:1px solid #b8e3c8;" +
  "text-align:center;";

counterInfo.innerHTML =
  '<div style="font-size:18px;font-weight:800;color:#087b45;margin-bottom:7px;">' +
  '💰 Többet szeretnél a készülékedért?' +
  '</div>' +
  '<div style="font-size:14px;line-height:1.6;color:#355b48;">' +
  'Ne hagyd veszni az üzletet! Add meg, mennyiért adnád el, ' +
  'mi pedig megvizsgáljuk az ajánlatodat.' +
  '</div>';

result.appendChild(counterInfo);
result.appendChild(counterBtn);
result.appendChild(rejectBtn);
}
var counterPanel = document.getElementById("ecoCounterOfferPanel");
if (!counterPanel) {
  counterPanel = document.createElement("div");
  counterPanel.id = "ecoCounterOfferPanel";
  counterPanel.style.cssText = "display:none;margin-top:12px;padding:18px;border:1px solid #d8e9d7;border-radius:16px;background:#fff;text-align:left;";
  counterPanel.innerHTML =
    '<div style="font-size:17px;font-weight:800;color:#225b31;margin-bottom:8px">Mennyi\u00e9rt adn\u00e1d el a k\u00e9sz\u00fcl\u00e9ked?</div>'+
    '<p style="font-size:13px;color:#667068;margin:0 0 14px">Az ellenaj\u00e1nlat nem jelent automatikus elfogad\u00e1st. Koll\u00e9g\u00e1ink megvizsg\u00e1lj\u00e1k a k\u00e9r\u00e9sedet.</p>'+
    '<label for="ecoCounterName" style="display:block;margin:8px 0 5px;font-weight:700">N\u00e9v</label>'+
    '<input id="ecoCounterName" type="text" maxlength="120" autocomplete="name" placeholder="Teljes neved" style="box-sizing:border-box;width:100%;padding:13px;border:1px solid #cbd9cd;border-radius:10px;font-size:16px">'+
    '<label for="ecoCounterEmail" style="display:block;margin:12px 0 5px;font-weight:700">E-mail-c\u00edm</label>'+
    '<input id="ecoCounterEmail" type="email" maxlength="254" autocomplete="email" placeholder="pelda@email.hu" style="box-sizing:border-box;width:100%;padding:13px;border:1px solid #cbd9cd;border-radius:10px;font-size:16px">'+
    '<label for="ecoCounterPrice" style="display:block;margin:12px 0 5px;font-weight:700">Az \u00e1ltalad k\u00e9rt \u00e1r (Ft)</label>'+
    '<input id="ecoCounterPrice" type="number" min="1000" max="10000000" step="1000" inputmode="numeric" placeholder="P\u00e9ld\u00e1ul: 75000" style="box-sizing:border-box;width:100%;padding:13px;border:1px solid #cbd9cd;border-radius:10px;font-size:16px">'+
    '<button id="ecoCounterSend" type="button" style="width:100%;margin-top:16px;padding:14px;border:0;border-radius:12px;background:#047857;color:#fff;font-weight:800;font-size:15px;cursor:pointer">Ellenaj\u00e1nlat elk\u00fcld\u00e9se</button>'+
    '<div id="ecoCounterMessage" role="status" aria-live="polite" style="margin-top:10px;font-size:13px"></div>';
  result.appendChild(counterPanel);
}
counterBtn.onclick = function () {
  counterPanel.style.display = counterPanel.style.display === "none" ? "block" : "none";
  var counterEmail = document.getElementById("ecoCounterEmail");
  if (counterEmail && !counterEmail.value) counterEmail.value = email;
};
var counterSend = document.getElementById("ecoCounterSend");
if (counterSend) counterSend.onclick = function () {
  var name = String(document.getElementById("ecoCounterName").value || "").trim();
  var counterEmail = String(document.getElementById("ecoCounterEmail").value || "").trim();
  var requested = Number(document.getElementById("ecoCounterPrice").value);
  var msg = document.getElementById("ecoCounterMessage");
  if (name.length < 2 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(counterEmail) || !Number.isSafeInteger(requested) || requested < 1000 || requested > 10000000) {
    msg.textContent = "K\u00e9rj\u00fck, add meg a neved, egy \u00e9rv\u00e9nyes e-mail-c\u00edmet \u00e9s a k\u00e9rt \u00f6sszeget (1 000\u201310 000 000 Ft).";
    msg.style.color = "#b42318";
    return;
  }
  counterSend.disabled = true;
  counterSend.textContent = "Ellenaj\u00e1nlat tov\u00e1bb\u00edt\u00e1sa...";
  var frameName = "ecoCounterFrame_" + Date.now();
  var frame = document.createElement("iframe");
  frame.name = frameName;
  frame.style.display = "none";
  document.body.appendChild(frame);
  var counterForm = document.createElement("form");
  counterForm.method = "POST";
  counterForm.action = ECO_OFFER_ENDPOINT;
  counterForm.target = frameName;
  counterForm.style.display = "none";
  var payload = {
    action: "counter-offer",
    offerId: currentOfferId,
    name: name,
    email: counterEmail,
    model: data.model,
    storage: data.storage,
    originalOfferPrice: String(data.offer),
    requestedPrice: String(requested)
  };
  Object.keys(payload).forEach(function (key) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = payload[key];
    counterForm.appendChild(input);
  });
  document.body.appendChild(counterForm);
  counterForm.submit();
  msg.style.color = "#256b36";
  msg.textContent = "";
  counterSend.textContent = "Bek\u00fcld\u00e9s elind\u00edtva";
  setTimeout(function () {
    if (counterForm.parentNode) counterForm.parentNode.removeChild(counterForm);
    if (frame.parentNode) frame.parentNode.removeChild(frame);
  }, 15000);
};

}

    emailInput.disabled=true;


    btn.textContent=
      "\u2713 AJ\u00C1NLAT ELK\u00DCLDVE";


    if(message){

      message.innerHTML=
        '<span style="color:#047857;font-weight:800;">'+
          '\u2713 Az aj\u00E1nlatot elk\u00FCldt\u00FCk a megadott e-mail c\u00EDmre.'+
        '</span>';

    }


    $("bbPrice").textContent=
      fmt(data.offer);


    $("bbSummary").innerHTML=

      '<ul>'+

        '<li>'+
          '<strong>'+esc(data.model)+'</strong>'+
          ' \u2022 '+
          esc(data.storage)+
          ' GB'+
        '</li>'+

        '<li>'+
          'V\u00E1rhat\u00F3 aj\u00E1nlat: '+
          '<strong>'+fmt(data.offer)+'</strong>'+
        '</li>'+

      '</ul>';


    var routeBtn=$("bbRouteBtn");


    if(routeBtn){

      routeBtn.onclick=openRoute;

    }
  }
// ==========================================
// AJ\u00C1NLAT ST\u00C1TUSZ\u00C1NAK FRISS\u00CDT\u00C9SE
// ==========================================

function updateOfferStatus(offerId, newStatus){

  if(!offerId){
    console.error("Nincs aj\u00E1nlat azonos\u00EDt\u00F3.");
    return;
  }

  var form = document.createElement("form");
  var frameName = "ecoStatusFrame_" + Date.now();

  var iframe = document.createElement("iframe");
  iframe.name = frameName;
  iframe.style.display = "none";

  document.body.appendChild(iframe);

  form.method = "POST";
  form.action = ECO_OFFER_ENDPOINT;
  form.target = frameName;
  form.style.display = "none";

  var fields = {
    action: "update-status",
    offerId: offerId,
    status: newStatus
  };

  Object.keys(fields).forEach(function(key){

    var input = document.createElement("input");

    input.type = "hidden";
    input.name = key;
    input.value = fields[key];

    form.appendChild(input);

  });

  document.body.appendChild(form);

  form.submit();

  setTimeout(function(){

    if(form.parentNode){
      form.parentNode.removeChild(form);
    }

    if(iframe.parentNode){
      iframe.parentNode.removeChild(iframe);
    }

  }, 5000);
}

  function calc(){

    var it=selected();


    if(!it){

      $("bbPrice").textContent=
        "\u2014 Ft";


      $("bbEcoModel").textContent=
        state.model||
        "V\u00E1lassz k\u00E9sz\u00FCl\u00E9ket";


      $("bbEcoMeta").textContent=
        "Haladj v\u00E9gig a l\u00E9p\u00E9seken, az \u00F6sszeget a v\u00E9g\u00E9n mutatjuk meg.";


      $("bbSummary").innerHTML=
        '<div class="bb-progress-note">'+
          'Az aj\u00E1nlat elk\u00E9sz\u00EDt\u00E9s\u00E9hez v\u00E1laszd ki a modellt, '+
          't\u00E1rhelyet \u00E9s \u00E1llapotot.'+
        '</div>';


      return;
    }


    var sum=0;

    var keys=Object.keys(state.picks);


    for(var i=0;i<keys.length;i++){

      if(keys[i] === "akku" && skipsBattery()) continue;

      var d=amount(
        it,
        state.picks[keys[i]]
      );


      if(d==="X"){

        $("bbPrice").textContent=
          "Egyedi aj\u00E1nlat";


        $("bbSummary").innerHTML=
          '<div class="bb-progress-note">'+
            'Ehhez az \u00E1llapothoz szem\u00E9lyes \u00E1tvizsg\u00E1l\u00E1s sz\u00FCks\u00E9ges.'+
          '</div>';


        return;
      }


      sum+=d;
    }


    var offer=Math.max(
      0,
      Number(it.BasePriceFt||0)-sum
    );


    $("bbEcoModel").textContent=
      it.Model+
      " \u2022 "+
      it.StorageGB+
      " GB";


    $("bbEcoMeta").textContent=

      keys.map(function(k){

        if(k === "akku" && skipsBattery()) return "";

        return k==="akku"

          ? (
              "Akku: "+
              state.akkuPercent+
              "% ("+
              akkuLabel(state.akkuPercent)+
              ")"
            )

          : label(state.picks[k]);

      })

      .filter(Boolean)

      .join(" \u2022 ");


    if(state.step<4){

      $("bbPrice").textContent=
        "Az aj\u00E1nlat k\u00E9sz\u00FCl\u2026";


      $("bbSummary").innerHTML=
        '<div class="bb-progress-note">'+

          '<strong>'+
            'M\u00E1r majdnem k\u00E9sz.'+
          '</strong>'+

          '<br>'+

          'Fejezd be az \u00E1llapotfelm\u00E9r\u00E9st, '+
          '\u00E9s a v\u00E9g\u00E9n megmutatjuk az \u00F6sszeget.'+

        '</div>';

    }else{

      $("bbPrice").textContent=
        "Aj\u00E1nlat elk\u00E9sz\u00FClt";


      $("bbSummary").innerHTML=

        '<div class="bb-progress-note">'+

          '<strong>'+
            'Az aj\u00E1nlatod elk\u00E9sz\u00FClt.'+
          '</strong>'+

          '<br>'+

          'Add meg az e-mail c\u00EDmed a v\u00E1rhat\u00F3 felv\u00E1s\u00E1rl\u00E1si \u00E1r megtekint\u00E9s\u00E9hez.'+

        '</div>';

    }
  }


  function render(){

    var panel=$("bbStepContent");


    if(panel){

      panel.classList.remove(
        "bb-content-enter"
      );

    }


    /* ============================================
       FONTOS SAMSUNG JAV\u00CDT\u00C1S

       Samsung Galaxy S / A eset\u00E9n nincs akku
       \u00E1llapot k\u00E9rd\u00E9s, ez\u00E9rt m\u00E9g a fejl\u00E9c
       kirajzol\u00E1sa el\u0151tt \u00E1tv\u00E1ltunk a kijelz\u0151re.
    ============================================ */

    if(
      state.step===3 &&
      skipsBattery() &&
      state.condition===0
    ){

      state.condition=1;

    }


    renderTop();


    if(state.step===0){

      renderHierarchy();

    }


    if(state.step===1){

      renderModels();

    }


    if(state.step===2){

      renderStorage();

    }


    if(state.step===3){

      renderCondition();

    }


    if(state.step===4){

      renderOffer();

    }


    calc();


    panel=$("bbStepContent");


    if(panel){

      void panel.offsetWidth;


      panel.classList.add(
        "bb-content-enter"
      );

    }
  }


  function resetAll(){

    state.step=0;

    state.condition=0;

    state.category="iphone";
    state.navStage=0;
    state.deviceGroup="";
    state.brandName="";
    state.familyName="";

    state.series="all";

    state.model="";

    state.storage="";

    state.akkuPercent=85;


    state.picks={

      akku:"D_Akku_Jo_Ft",

      kijelzo:"D_Kijelzo_Karcmentes_Ft",

      keret:"D_Keret_Szep_Ft",

      hatlap:"D_Hatlap_Szep_Ft",

      beeges:"D_Beeges_Nincs_Ft",

      pixel:"D_Pixelhiba_Nincs_Ft",

      tartozek:"D_Tartozek_Megvan_Ft"

    };


    visible=12;


    render();
  }


  function openRoute(){

    var modal=$("bbRouteModal");


    if(!modal){

      return;

    }


    modal.classList.add(
      "is-open"
    );


    modal.setAttribute(
      "aria-hidden",
      "false"
    );
  }


  function closeRoute(){

    var modal=$("bbRouteModal");


    if(!modal){

      return;

    }


    modal.classList.remove(
      "is-open"
    );


    modal.setAttribute(
      "aria-hidden",
      "true"
    );
  }


  function routeUrl(mode){

    var place=
      "Etele Pl\u00E1za, Budapest";


    if(mode==="place"){

      return (
        "https://www.google.com/maps/place/Eco+Mobil+Etele+Pl%C3%A1za+-+szerviz/@47.4640452,19.0233076,17z/data=!3m1!4b1!4m6!3m5!1s0x4741ddc2531f8efb:0x924d80958163afe3!8m2!3d47.4640416!4d19.0258879!16s%2Fg%2F11hy_x58km?entry=ttu&g_ep=EgoyMDI2MDcxNS4wIKXMDSoASAFQAw%3D%3D"+
        encodeURIComponent(place)
      );

    }


    return (

      "https://www.google.com/maps/place/Eco+Mobil+Etele+Pl%C3%A1za+-+szerviz/@47.4640452,19.0233076,17z/data=!3m1!4b1!4m6!3m5!1s0x4741ddc2531f8efb:0x924d80958163afe3!8m2!3d47.4640416!4d19.0258879!16s%2Fg%2F11hy_x58km?entry=ttu&g_ep=EgoyMDI2MDcxNS4wIKXMDSoASAFQAw%3D%3D"+

      encodeURIComponent(place)+

      "&travelmode="+mode

    );
  }


  function boot(data){

    items=data;


    /* ============================================
       VISSZA GOMB
       SAMSUNG ELS\u0150 \u00C1LLAPOTN\u00C1L NEM MEGY AKKURA
    ============================================ */

    $("bbBack").onclick=function(){
      if(state.step===1){state.step=0;state.navStage=2;state.model="";state.storage="";render();return;}
      if(state.step===0 && state.navStage>0){state.navStage--;render();return;}
      var isSamsung = skipsBattery();


      if(state.step===3){

        if(
          isSamsung &&
          state.condition===1
        ){

          state.step=2;

          state.condition=0;

        }else if(state.condition>0){

          state.condition--;

        }else if(state.step>0){

          state.step--;

        }

      }else if(state.step>0){

        state.step--;


        if(state.step===3){

          state.condition=
            conds.length-1;

        }
      }


      render();
    };


    $("bbNext").onclick=function(){

      if(this.disabled){

        return;

      }


      if(state.step===4){

        resetAll();

        return;

      }


      if(
        state.step===3 &&
        state.condition<conds.length-1
      ){

        state.condition++;

      }else if(state.step<4){

        state.step++;

      }


      render();
    };


    $("bbReset").onclick=
      resetAll;


    var routeClose=
      $("bbRouteClose");


    if(routeClose){

      routeClose.onclick=
        closeRoute;

    }


    var modal=
      $("bbRouteModal");


    if(modal){

      modal.onclick=function(e){

        if(e.target===modal){

          closeRoute();

        }

      };
    }


    Array.prototype.forEach.call(
      document.querySelectorAll(".bb-route-go"),
      function(btn){

        btn.onclick=function(){

          window.open(
            routeUrl(
              this.getAttribute("data-mode")
            ),
            "_blank",
            "noopener"
          );

        };

      }
    );


    render();
  }


  function data(){

    return (

      window.BUYBACK_PRICE_DATA &&
      window.BUYBACK_PRICE_DATA.items

    )

    ||

    window.IPHONE_BUYBACK_PRICELIST

    ||

    null;
  }


  function wait(){

    var n=0;


    var t=setInterval(function(){

      var d=data();


      if(
        d &&
        d.length
      ){

        clearInterval(t);

        boot(d);

      }else if(++n>50){

        clearInterval(t);


        if($("bbAlert")){

          $("bbAlert").style.display=
            "block";


          $("bbAlert").textContent=
            "Nem t\u00F6lt\u0151d\u00F6tt be az \u00E1rlista.";

        }
      }

    },100);
  }


  if(document.readyState==="loading"){

    document.addEventListener(
      "DOMContentLoaded",
      wait
    );

  }else{

    wait();

  }

})();